var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-input',{attrs:{"type":"switch"},on:{"change":function($event){return _vm.updateConfirmed($event.target.value)}},model:{value:(_vm.switchValue),callback:function ($$v) {_vm.switchValue=$$v},expression:"switchValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }